import Button from '../Button/Button';

import styles from './FullBanner.module.scss';

const FullBanner = ({ data }) => {
  return (
    <div
      className={styles.full_banner_wrapper}
      style={{ backgroundImage: `url(${data?.image})` }}
      role='banner'
      itemScope
      itemType='http://schema.org/Offer'
    >
      <div className={styles.content}>
        {data?.top_text && (
          <span className={styles.top_text}>{data.top_text}</span>
        )}
        {data?.title && <h2 className={styles.title}> {data.title}</h2>}
        {data?.description && (
          <p className={styles.description}> {data.description}</p>
        )}
        {data?.button_text && data?.button_slug && (
          <Button
            Component={'router'}
            href={data?.button_slug}
            className={styles.content_btn}
          >
            {data?.button_text}
          </Button>
        )}
      </div>
    </div>
  );
};

export default FullBanner;
